import React from "react";
import TextInput from "common/TextInput";
import PasswordInput from "common/PasswordInput";
import SelectInput from "common/SelectInput";
import NamesList from "./Common/NamesList";
import SwitchInput from "common/SwitchInputWithState";
import Wrapper from "./Common/Wrapper";

const azotelBillingSubscribers = [
  { label: "Leave unchanged", value: "unchanged" },
  { label: "Customer ID", value: "customer-id" },
  { label: "Name", value: "name" },
  { label: "Nickname", value: "nickname" },
];

const dictionary = {
  'user-name': 'name',
  'login': 'nickname',
}

function translate(input){
  return dictionary[input] ?? input;
}

const AzotelBillingSettingsInputs = ({ onChange, defaults = {}, state = {} }) => (
  <>
    <TextInput
      type="text"
      label="User:"
      name="username"
      className="input-group"
      defaultValue={defaults.username}
      onChange={onChange}
    />
    <PasswordInput
      defaultValue={defaults.password}
      className="input-group"
      name="password"
      onChange={onChange}
    />
    <Wrapper>
      <SelectInput
        label="Subscriber-ID source"
        name="subscriberIdSource"
        className="input-group margin-b-20"
        defaultValue={defaults.subscriberIdSource ==="n/a" || defaults.subscriberIdSource === undefined ? "unchanged" : translate(defaults.subscriberIdSource)}
        onChange={onChange}
        options={azotelBillingSubscribers}
      />
    </Wrapper>
    <SwitchInput
      defaultChecked={defaults.azotelPolicyName}
      name="azotelPolicyName"
      label="Policy names from Azotel bucket names"
      onChange={onChange}
    />
    <NamesList
      fieldLabel="Radius Id"
      className="has-input-groups column-prefer-left"
      onChange={({ list }) =>
        onChange(null, { name: "azotelRadiusIds", value: list })
      }
      state={state}
      defaults={{ list: defaults.azotelRadiusIds || [] }}
    />
  </>
);

export default AzotelBillingSettingsInputs;
